import iconMilitary from '../../assets/3-military.svg';
import iconMilitaryReverse from '../../assets/3-military-intro.svg';
import iconNuclear from '../../assets/3-nuclear.svg';
import iconNuclearReverse from '../../assets/3-nuclear-intro.svg';
import iconCyber from '../../assets/3-next.svg';
import iconCyberReverse from '../../assets/3-next-intro.svg';
import TopicTree from './TopicTree';

// TODO - fix this in the backend
export const getIconUrl = iconName => {
  switch (iconName) {
    case 'Military':
      return {
        iconDefault: iconMilitary,
        iconReverse: iconMilitaryReverse,
      };
    case 'Nuclear':
      return {
        iconDefault: iconNuclear,
        iconReverse: iconNuclearReverse,
      };
    case 'Cyber':
      return {
        iconDefault: iconCyber,
        iconReverse: iconCyberReverse,
      };
    default:
      return {};
  }
};

export default TopicTree;



// WEBPACK FOOTER //
// ./src/components/TopicTree/index.js